<template>
  <span
    class="align-middle"
    :style="`display:inline-block; color: currentColor; mask: url(${path}) no-repeat center;`"
    ><div
      :style="`color: currentColor; background: currentColor; width:${size}px; height:${size}px;`"
    ></div
  ></span>
</template>

<script>
export default {
  name: "Icon22",

  data: function () {
    return {};
  },

  props: {
    size: { type: Number, default: 16 },
    icon: String,
  },

  computed: {
    path() {
      return "icons/" + this.icon + ".svg";
    },
  },
};
</script>

<style scoped>
img {
  margin-bottom: 2px;
}
</style>
